import ActionBar from '../../../components/ActionBar/NewActionBar';
import CompanyOwnRessources from '../../../components/Assistance/CompanyOwnRessource/CompanyOwnRessource';
import React from 'react';
import { AssistanceStackParamList } from '../../../types/navigation';
import { View } from 'react-native';
import { assistanceKey } from '../../../constants/routeKeys';
import { concatPath } from '../../../utils/links/concatPath';
import { isIos } from '../../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useStores } from '../../../hooks/useStores';


type AssistanceProps = AssistanceStackParamList['AssistanceOwn'];


const AssistanceOwn: React.FunctionComponent<AssistanceProps> = observer(() => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.ASSISTANCE;



  const onPressAssistance = () => {
    router.navigate(concatPath([assistanceKey],0));

  };

  return (
    <View style={[isIos && {marginTop: 40}, {flex: 1}]}>
      <ActionBar
        width='100%'
        height={40}
        title={labels?.OWN?.TITLE}
        onExit={()=> {}}
        onPrevious={onPressAssistance}
        hideExit={true}
      />


      <CompanyOwnRessources errorMessageIfNone={true}/>
    </View>
  );
});


export default AssistanceOwn;
